let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kR0fk")).then(() => parcelRequire('Iv6Dt'));